var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModalClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2933 18.707C11.4808 18.8945 11.7351 18.9998 12.0003 18.9998C12.2654 18.9998 12.5197 18.8945 12.7073 18.707L15.0003 16.414L17.2933 18.707C17.4819 18.8892 17.7345 18.99 17.9967 18.9877C18.2589 18.9854 18.5097 18.8803 18.6951 18.6949C18.8805 18.5095 18.9857 18.2586 18.9879 17.9964C18.9902 17.7342 18.8894 17.4816 18.7073 17.293L16.4143 15L18.7073 12.707C18.8894 12.5184 18.9902 12.2658 18.9879 12.0036C18.9857 11.7414 18.8805 11.4906 18.6951 11.3052C18.5097 11.1198 18.2589 11.0146 17.9967 11.0124C17.7345 11.0101 17.4819 11.1109 17.2933 11.293L15.0003 13.586L12.7073 11.293C12.5187 11.1109 12.2661 11.0101 12.0039 11.0124C11.7417 11.0146 11.4909 11.1198 11.3055 11.3052C11.12 11.4906 11.0149 11.7414 11.0126 12.0036C11.0103 12.2658 11.1111 12.5184 11.2933 12.707L13.5863 15L11.2933 17.293C11.1058 17.4806 11.0005 17.7349 11.0005 18C11.0005 18.2652 11.1058 18.5195 11.2933 18.707Z",
    fill: "#99A4A3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    stroke: "#EFF5F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalClose);
export default __webpack_public_path__ + "static/media/modalClose.686f63b338165c8fc9e3606495018660.svg";
export { ForwardRef as ReactComponent };